module.exports = __webpack_public_path__ + "static/media/verbot_nutzfahrzeuge.39611458.svg";